// Generator-discovered file route for the job-progress surface. Component lives
// in `src/ad/routes/jobs.tsx` (Module K / K3). Reads the `creativeId` search
// param and passes it as a prop.
import { createFileRoute } from '@tanstack/react-router';
import { JobsRouteComponent } from '@/ad/routes/jobs';

function parseCreativeId(search: Record<string, unknown>): { creativeId?: number } {
  const raw = search.creativeId;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isInteger(n) && n > 0 ? { creativeId: n } : {};
}

export const Route = createFileRoute('/_authenticated/ad/jobs')({
  validateSearch: parseCreativeId,
  component: JobsRoute,
});

function JobsRoute(): React.ReactElement {
  const { creativeId } = Route.useSearch();
  return <JobsRouteComponent creativeId={creativeId} />;
}
